<template>
  <div
    class="answer-icon"
    :class="{ 'answer-icon_checked': checked }"
    @click="emitClick"
  >
    <div class="answer-icon__image-wrapper">
      <inline-svg
        @loaded="emitIconLoaded"
        class="answer-icon__image"
        :src="require(`@/assets/images/${image}`)"
      />
    </div>
    <div class="answer-icon__answer">
      <slot></slot>
    </div>
    <div
      v-if="note"
      class="answer-icon__note"
    >
      {{ note }}
    </div>
  </div>
</template>

<script>

export default {
  name: 'answer-icon',
  props: {
    image: {
      type: String,
      required: true,
    },
    note: {
      type: String,
    },
    color: {
      type: String,
    },
    checked: Boolean,
  },
  methods: {
    emitIconLoaded() {
      this.$emit('icon-loaded');
    },
    emitClick(event) {
      this.$emit('click', event);
    },
  },
};
</script>

<style lang="scss">
@import '~@/styles/variables';
@import '~@/styles/mixins';

.answer-icon {
  cursor: pointer;
  text-align: center;
  width: 100%;
  @media (min-width: 650px){
    width: 200px;
  }


  &__answer {
    color: $primary-blue;
    font: {
      family: 'Roboto';
      weight: 500;
      size: 16px;
    }
    letter-spacing: 1.5px;
    text-transform: uppercase;
  }

  &__note {
    font: {
      family: 'Avenir Next';
      weight: normal;
      size: 16px;
    }
    color: #828282;
  }

  &_checked {

    .answer-icon__answer {

      @include checked-mark;

    }

  }

}
</style>
